import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { DesignSystem } from '../models/DesignSystem'
import { DesignSystemForm } from '../forms/DesignSystemForm'
import { DesignSystemFilter } from '../filters/DesignSystemFilter'
import { DesignSystemService } from '../services/DesignSystemService'

export const useDesignSystemStore: KsStoreHook<DesignSystem, DesignSystemForm, DesignSystemFilter> = createKsStore({
  id: 'designSystems',
  modelClass: DesignSystem,
  formClass: DesignSystemForm,
  filterClass: DesignSystemFilter,
  service: DesignSystemService,
  uniqueField: 'name',
  labelField: (item) => item.name || `Design System #${item.id}`,
  signalREventName: 'DesignSystemModel',
  isReferential: true
})
